import React, { useEffect, useState } from "react";
// import {Tabs,Tab} from 'react-bootstrap';
import { useTranslation } from "react-i18next";
//compoents
import { StatementTable, HistoryTable, WalletTable, EarningsTable } from "./";
import Tabs from "react-responsive-tabs";
import style from "./codeactive.module.scss";
import { propTypes } from "react-bootstrap/esm/Image";
import { useSelector } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataTable from "react-data-table-component";
import moment from "moment";
import Filter from "./Filter";
import TransactionlistModal from "./TransactionlistModal";
import OrderService from "../../../service/orderHistory/orderHistory";
import { formatNumberWithCommasAndDecimal } from "../../helper";

const stylees = {
  paddingTop: "10px",
  fontFamily: "system-ui",
};

function Content({
  tableData,
  loader,
  changeOrdersTable,
  datehandler,
  resetdata,
  // changeHandler,
  // paginationHandler,
  // repurchase_status,
  exportData,
  printloader,
  // loader,
}) {
  const Currency = useSelector((state) => state.curr);
  const [date, SetDate] = useState({
    start: moment().startOf("month").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
  });
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  console.log("tableData", tableData);
  const [modalShow, setModalShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedInvoicedata, setSelectedInvoicedata] = useState(null);
  const [selectedQRData, setSelectedQRData] = useState(null);
  const [type, setType] = useState("");
  // console.log('gfgf',date.start);
  const handleClose = () => {
    setModalShow(false);
  };
  const columns = [
    {
      name: <div>Transcation Date</div>,
      // selector: (row) => moment(row.date_added).format("MM/DD/YYYY h:m:ss"),
      selector: (row) =>
        moment
          .utc(row.date_added)
          .subtract(8, "hours")
          .tz("Asia/Manila")
          .format("MM/DD/YYYY h:mm:ss A"),
      // selector: (row) => row.date_added,
      width: "10%",
      sortable: true,
    },
    {
      name: <div>TransactionNo/Order #</div>,
      selector: (row) => row.order_id_with_prefix,
      width: "12%",
      sortable: true,
    },
    {
      name: <div>Transaction Type</div>,
      selector: (row) => row.shipping_method,
      width: "10%",
      sortable: true,
    },
    {
      name: <div>Gross</div>,
      // selector: (row) => row.gross,
      cell: (row) => (
        <span>
          {Currency.currentCurr}{" "}
          {formatNumberWithCommasAndDecimal(
            row.gross * Currency.value,
            Currency.precision
          )}
        </span>
      ),
      width: "10%",
      // sortable: true,
    },
    {
      name: <div>Delivery Method</div>,
      selector: (row) => row.delivery_mode,
      width: "10%",
      sortable: true,
    },
    {
      name: <div>Delivery Address</div>,
      selector: (row) => row.delivery_address,
      width: "10%",
      sortable: true,
    },
    {
      name: <div>Payment Type</div>,
      selector: (row) => row.payment_method,
      width: "10%",
      sortable: true,
    },
    {
      name: <div>Status</div>,
      selector: (row) => row.status,
      width: "8%",
      sortable: true,
    },
    {
      name: <div>Sales Invoice</div>,
      selector: (row) => row.sales_invoice,
      width: "8%",
      sortable: true,
    },
    {
      name: <div>Tracking No</div>,
      selector: (row) => row.trackingNumber,
      width: "8%",
      sortable: true,
    },
    {
      name: <div>Code Status</div>,
      selector: (row) => row.codeUsedOrNot,
      width: "8%",
      sortable: true,
    },
    {
      name: "action",
      selector: (row) => (
        <div>
          {row.qr === 1 && (
            <u
              onClick={() => handleQRActionClick(row)}
              style={{
                cursor: "pointer",
                backgroundColor: "#4CAF50",
                color: "white",
                padding: "10px 20px",
                border: "none",
                borderRadius: "8px",
                fontSize: "10px",
                textAlign: "center",
                textDecoration: "none",
                display: "inline-block",
                transition: "background-color 0.3s ease",
              }}
            >
              View QR
            </u>
          )}
          <u
            onClick={() => handleActionClick(row)}
            style={{ cursor: "pointer" }}
          >
            View Details
          </u>
        </div>
      ),
      width: "8%",
    },
  ];
  const handleActionClick = (row) => {
    setType("history");
    console.log("rowww inside row click", row);
    let service = new OrderService();
    service.getOrderdetails(row.order_id).then((res) => {
      // if(res.status){
      if (res?.error) {
        console.log("error", res?.error?.description);
      } else {
        console.log("res", res.codeResult);
        setSelectedInvoicedata(res);
        setModalShow(true);
      }
    });
  };

  const handleQRActionClick = (row) => {
    console.log(" ===qr === ");
    setType("qr");
    console.log(" ===qr === ", row);
    let service = new OrderService();
    service.getQROrderdetails(row.order_id).then((res) => {
      // if(res.status){
      console.log(res, "===qr === res");
      if (res?.error) {
        console.log("error", res?.error?.description);
      } else {
        console.log("res", res.codeResult);
        setSelectedQRData(res);
        setModalShow(true);
      }
    });
  };

  const closeModal = () => {
    setModalShow(false);
    // setSelectedInvoice(null);
  };

  const handlePageChange = (inPage) => {
    changeOrdersTable(inPage, tableData.perPage);
  };

  const handlePerRowsChange = (perPage, inPage) => {
    changeOrdersTable(inPage, perPage);
  };
  const filterHandlet = (start, end, type = "") => {
    console.log("start, end", start, end);
    SetDate((prev) => ({
      ...prev,
      start: start,
      end: end,
      // selectedValues: type,
    }));
    datehandler(start, end);
  };
  const resetData = () => {
    resetdata();
  };

  return (
    <div className="modalTransaction">
      <div className={style.summary}>
        <div
          className={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_tabContent}`
              : `${style.tabContent}`
          }`}
        >
          <div>
            <h5>{t("Common.storetransationhistory")}</h5>
          </div>
          <div className="modalTransaction">
            <div className={style.dataTable} style={stylees}>
              <Filter
                filterHandler={filterHandlet}
                // type={ConvertData(ContentData.category)}
                resetHandler={resetData}
                isSingle={false}
                exports={true}
                exportData={exportData}
                // ContentData={ContentData}
                loader={loader}
                printloader={printloader}
              />
              <TransactionlistModal
                show={modalShow}
                handleClose={handleClose}
                data={selectedInvoicedata}
                // productdata={productdata}
                qrData={selectedQRData}
                onHide={() => setModalShow(false)}
                type={type}
              />

              <DataTable
                columns={columns}
                data={tableData.data}
                highlightOnHover
                progressPending={loader}
                progressComponent={<div>Loading</div>}
                persistTableHead
                noHeader
                pagination
                paginationServer
                responsive
                paginationTotalRows={tableData.totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                noDataComponent={t("Common.noDataRecordsToDisplay")}
                // //onSort={handleOnSort}
                exportData={exportData}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Content;
